/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { getComponentByType } from "cms/components/components/component";
import { NoComponentEditorAvailable } from "cms/components/layout/empty/no-editor-available";
import { useCurrentDynamicField } from "cms/fields/hooks/use-current-dynamic-field";
import { useComposerMode } from "../hooks/use-composer-mode";

/**
 * @type {import('react').FC<DynamicComponentProps>}
 */
const DynamicComponent = (props) => {

    const component = props?.component;
    const index = props?.index;
    const count = props?.count;
    const hide = props?.hide;
    const webpage = props?.webpage;
    
    const type = component?.type;
    const defaultPosition = index + 1;
    const { position = defaultPosition } = component || {};
    
    const { editMode, contentOnly } = useComposerMode();
    const { field } = useCurrentDynamicField();
    const fieldName = field?.name;

    const Component = getComponentByType(type);
    
    if (Component) {
        const key = component?.guid;
        return (
            <Component
                key={key}
                fieldName={fieldName}
                component={component}
                position={position}
                index={index}
                count={count}
                contentOnly={contentOnly}
                editMode={editMode}
                hide={hide}
                webpage={webpage}
            />
        );
    } else {
        return (
            <NoComponentEditorAvailable
                fieldName={fieldName}
                editMode={editMode}
                component={component}
            />
        );
    }
};

export { DynamicComponent };

/**
 * @typedef {object} DynamicComponentProps
 * @property {ComponentLike} component
 * @property {number} index
 * @property {number} count
 * @property {boolean} hide
 * @property {object} webpage
 */
